"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("circle", {
  cx: "12",
  cy: "12",
  r: "8"
}), 'FiberManualRecord');